import { Controller } from "stimulus";
import autoComplete from 'js-autocomplete';

export default class extends Controller {
  setupAutocomplete() {
    let abortController;
    let suggestions = {};

    this.autocomplte = new autoComplete({
      selector: this.element,
      minChars: 1,
      source: (term, suggest) => {
        if(term === "") {
          return;
        }
        if(suggestions[term]) {
          suggest(suggestions[term]);
          return;
        }
        if(suggestions[term.charAt(0)]) {
          suggestions[term] = suggestions[term.charAt(0)].filter(s => ~s.toLowerCase().indexOf(term));
          suggest(suggestions[term]);
          return;
        }

        abortController && abortController.abort();
        abortController = new AbortController();

        const fullUrl = this.toFullUrl(this.sourceUrl, {...this.sourceQueries, name: term});
        fetch(fullUrl, {signal: abortController.signal})
          .then(RES => RES.json())
          .then(function(_suggestions){
            suggestions[term] = _suggestions;
            suggest(_suggestions);
          })
      }
    });
  }

  connect() {
    this.sourceUrl = this.element.dataset.sourceUrl;
    this.sourceQueries = JSON.parse(this.element.dataset.sourceQueries);
    this.setupAutocomplete();
  }

  toFullUrl(url, queries) {
    let qs = "";
    Object.keys(queries).forEach(key => {
      qs += qs === "" ? "?" : "&";
      qs += `${key}=${queries[key]}`;
    });
    return url + qs;
  }
}
